module.exports = __webpack_public_path__ + "img/StreetUnverCity16.472e828e.jpg";